module.exports = __webpack_public_path__ + "img/concluido.87ce3f01.svg";